/**
 * @author: dongjing
 * @file: 置顶标志
 * @Date: 2020-01-08 17:37:59
 * @LastEditors: dongjing
 * @LastEditTime: 2020-01-08 17:38:57
 */
import React from 'react';
import './Pinned.less';

export interface IPinnedProps {}
type Props = IPinnedProps;

export function Pinned(props: Readonly<Props>) {
  return <div className="common-presenter k-common-pinned">置顶</div>;
}

export default Pinned;
